import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div
      id='libraryCustomersFolderPreview'
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p id='libraryCustomersFolderPreviewText'>
        This is where you will find your customer documents, including agreements and contracts. Any
        customer documents you upload or create on the platform will be stored here.
      </p>
    </div>
  );
};

export default Preview;
